
import ogPagesMixins from '@/mixins/ogPagesMixins'
export default {
  mixins: [ogPagesMixins],
  props: {
    stream: {
      type: Object,
      default: null,
    },
  },
  computed: {
    seoTitle() {
      return `${this.stream?.stream?.title} : изображения | Мегасреда`
    },
    seoDescription() {
      return `Все изображения журнала ${this.stream?.stream?.title}`
    },
    seoH1() {
      return `Изображения относящиеся к журналу ${this.stream?.stream?.title}`
    },
    seoImage() {
      return {
        url: `https://api.megasreda.ru/image/ogimage/stream/${this.stream?.stream?.id}.jpg`,
        urlVk: `https://api.megasreda.ru/image/ogimage/stream/vk/${this.stream?.stream?.id}.jpg`,
        urlTw: `https://api.megasreda.ru/image/ogimage/stream/${this.stream?.stream?.id}.jpg`,
        type: 'image/jpeg',
        width: 1200,
        height: 630,
      }
    },
  },
}
